// 付款狀態

export const INIT = 'init' // 未付款
export const PENDING = 'pending' // 未付款
export const APPROVING = 'approving' // 待審核
export const PAID = 'paid' // 已付款
export const REFUNDED = 'refunded' // 已退款
